// import smoothscroll from 'smoothscroll-polyfill'
//smoothscroll.polyfill()
const numbers = document.getElementsByClassName('numbers__wrapper')
if (numbers) {
    Array.from(numbers)
        .forEach((children) => {
            if (children) {
                // console.log(scrolledP)
                const numArrowNodesP = children.getElementsByClassName('numbers__arrow')
                const numBackNodesP = children.getElementsByClassName('numbers__arrow-back')
                const numNodes = children.getElementsByClassName('numbers__list')

                if (numArrowNodesP.length > 0) {
                    let scrolledP = 0
                    const arrowsP = Array.from(numArrowNodesP)
                    const backsP = Array.from(numBackNodesP)
                    const pages = Array.from(numNodes)

                    arrowsP.map((arrow, key) => {
                        arrow.addEventListener('click', () => {
                            if (pages[key].scrollLeft + pages[key].offsetWidth < pages[key].scrollWidth) {
                                scrolledP += 300
                            }

                            pages[key].scroll({
                                top: 0,
                                left: scrolledP,
                                behavior: 'smooth'
                            })
                            if (((pages[key].scrollLeft + pages[key].offsetWidth) % pages[key].scrollWidth) + 300 >= pages[key].scrollWidth) {
                                arrow.classList.add('end')
                            }
                            if (scrolledP != 0) {
                                numBackNodesP[0].classList.remove('end')
                            }
                        })

                        arrow.addEventListener('keyup', (e) => {
                            e = e || window.KeyboardEvent
                            if (e.key === 'ArrowRight') {
                                if (pages[key].scrollLeft + pages[key].offsetWidth < pages[key].scrollWidth) {
                                    scrolledP += 300
                                }
                                // console.log(scrolledP)
                                pages[key].scroll({
                                    top: 0,
                                    left: scrolledP,
                                    behavior: 'smooth'
                                })
                                if (((pages[key].scrollLeft + pages[key].offsetWidth) % pages[key].scrollWidth) + 300 >= pages[key].scrollWidth) {
                                    arrow.classList.add('end')
                                }
                                if (scrolledP != 0) {
                                    numBackNodesP[0].classList.remove('end')
                                }
                            }
                        })
                    })

                    backsP.map((arrow, key) => {
                        arrow.addEventListener('click', () => {
                            if (scrolledP > 0) {
                                scrolledP -= 300
                            }

                            pages[key].scroll({
                                top: 0,
                                left: scrolledP,
                                behavior: 'smooth'
                            })

                            if (scrolledP == 0) {
                                arrow.classList.add('end')
                            }
                            numArrowNodesP[0].classList.remove('end')

                        })

                        arrow.addEventListener('keyup', (e) => {
                            e = e || window.KeyboardEvent
                            // console.log(e.key)
                            if (e.key === 'ArrowLeft') {
                                if (scrolledP > 0) {
                                    scrolledP -= 300
                                }

                                pages[key].scroll({
                                    top: 0,
                                    left: scrolledP,
                                    behavior: 'smooth'
                                })

                                if (scrolledP == 0) {
                                    arrow.classList.add('end')
                                }
                                numArrowNodesP[0].classList.remove('end')
                            }
                        })
                    })
                }
            }
        })
}